import { Ref } from '@tblabs/truffle';
import { ServerInfo } from './ServerInfo';
import { PasswordSanitizer } from './PasswordSanitizer';


export class AppConfigProvider 
{
    public ServerId = new Ref<string>("H1").Storable("server-id");
    private password: string = "";
    public AdminToken: string = "";

    public ServersPool: ServerInfo[] = [
        { Id: "H1", Name: "Server H1", Addr: "https://transcorder-server.herokuapp.com" },
        { Id: "H2", Name: "Server H2", Addr: "https://snapcam-c63944959af1.herokuapp.com" }, 
        { Id: "A1", Name: "Server A1", Addr: "https://transcorderserver.azurewebsites.net" },
        { Id: "S1", Name: "Server S1", Addr: "https://camera.specteam.pl:5005" },
        { Id: "R1", Name: "Server R1", Addr: "http://radio2.specteam.pl" },
        { Id: "L1", Name: "Server L1", Addr: "http://localhost:5005" },
        { Id: "L2", Name: "Server L2", Addr: "http://192.168.0.54:5005" },
    ];

    constructor(serverId?: string, password?: string, adminToken?: string)
    {
        if (serverId)
        {
            this.ServerId.value = serverId;
        }

        if (password)
        {
            this.password = PasswordSanitizer.Sanitize(password);
        }

        if (adminToken)
        {
            this.AdminToken = adminToken;
        }
    }

    public get Password(): string
    {
        return PasswordSanitizer.Sanitize(this.password);
    }

    public get ServerInfo(): ServerInfo
    {
        return this.ServersPool.find(x => x.Id == this.ServerId.value) || this.ServersPool[0];
    }
}
